var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vxe-table",
        { attrs: { "row-id": "id", data: _vm.datalist, align: "left" } },
        [
          _c("vxe-table-column", {
            attrs: {
              field: "name",
              "show-overflow": "",
              "min-width": "120",
              title: "名称",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "identifier",
              "show-overflow": "",
              "min-width": "120",
              title: "标识符",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "data_value",
              "show-overflow": "",
              "min-width": "120",
              title: "数据值",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "data_type",
              "show-overflow": "",
              "min-width": "120",
              title: "数据类型",
            },
          }),
        ],
        1
      ),
      _vm.total
        ? _c("v-pagination", {
            attrs: {
              total: _vm.total,
              name: "page-basic",
              "is-show-total": "",
              "is-change-size": "",
              "is-input-page": "",
              "current-page": this.currentPage,
            },
            on: {
              "change-page": _vm.changePage,
              "change-size": _vm.changeSize,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }